// src/AppMenu.js
import React from 'react';
import { Menu } from 'antd';
import {
  MessageOutlined,
  UserOutlined,
  HistoryOutlined
} from '@ant-design/icons';

const AppMenu = ({ activeKey, onClick, role }) => {
  return (
    <Menu
      theme="dark"
      mode="inline"
      defaultSelectedKeys={activeKey}
      onClick={onClick}
      items={[
        {
          key: '1',
          icon: <MessageOutlined />,
          label: 'ChatList'
        },
        role === ('Admin' || 'SysAdmin')
          ? {
              key: '2',
              icon: <UserOutlined />,
              label: 'Team'
            }
          : null,
        {
          key: '3',
          icon: <HistoryOutlined />,
          label: 'History'
        }
      ]}
    />
  );
};

export default AppMenu;
